// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clickable[data-v-6fc3a8b3]{cursor:pointer}.v-btn[data-v-6fc3a8b3]{margin:8px 0}", ""]);
// Exports
module.exports = exports;
